<div *transloco="let t">
	<div class="py-4">
		<h2 class="headline">{{ t('printSettings.coverLetterTitle') }}</h2>
		@if (presetContact() || sessionService.isPropertyManagement()) {
			<div class="mt-4 flex flex-row justify-start items-center">
				{{ t('settings.originOfCoverLetter') }}
				<span class="pl-1" style="line-height: 100%">
					<mat-icon [svgIcon]="icons.get('infoOutline')" [siTooltip]="t('settings.coverLetterTextExplanation')" style="font-size: 20px"></mat-icon>
				</span>
			</div>
			<p>
				<mat-radio-group
					class="flex flex-col"
					(change)="updateCoverLetterSelection()"
					[(ngModel)]="currentPropertyManagementSetting.readCoverLetterFromServiceCompany">
					<mat-radio-button [value]="true" name="radioButtonUseUviCoverletterSC" [title]="t('settings.coverLetterServiceCompany')">
						{{ t('settings.getFromServiceCompany') }}
					</mat-radio-button>
					<mat-radio-button
						[value]="false"
						name="radioButtonUseUviCoverletterPM"
						[title]="propertyManagementEnabled ? t('settings.coverLetterPropertyManagement') : t('settings.noPropertyManagementSelected')">
						{{ t('settings.getFromPropertyManagement') + propertyManagementName }}
					</mat-radio-button>
				</mat-radio-group>
			</p>
		}

		@if (sessionService.isPropertyManagement() && !currentPropertyManagementSetting.readCoverLetterFromServiceCompany) {
			<div class="w-2/4 ml-12">
				<mat-form-field appearance="fill" class="w-full">
					<mat-label>{{ t('common.propertyManagement') }}</mat-label>
					<mat-select
						[value]="selectedContact"
						[compareWith]="compareContactsWithAreas"
						(selectionChange)="changeContact($event)"
						[disabled]="possiblePropertyManagements.length === 1"
						name="pmSelect">
						@for (pm of possiblePropertyManagements; track pm.id) {
							<mat-option [value]="pm">
								{{ pm.name + ' (' + pm.serviceCompanyName + ')' }}
							</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>
		}

		<div class="ml-12">
			<ara-uvi-letter
				(coverTextChange)="formChanged('coverLetter'); previewValid = false"
				[(coverText)]="coverLetter"
				[editable]="allowEdit()"
				[disabled]="!allowEdit()"></ara-uvi-letter>
			<p class="m-2">{{ t('settings.codePlaceholder') }}</p>
			<p class="m-2">{{ t('settings.datePlaceholder') }}</p>
		</div>
	</div>
	<div class="flex flex-row justify-end items-center">
		<ara-spinner-button
			[action]="onShowPreview.bind(this)"
			[disabledWhenSpinning]="true"
			[hideTextOnMobile]="true"
			[showSpinner]="!previewFinishedLoading()"
			[svgIcon]="icons.get('preview')"
			buttonText="{{ t('settings.pdfPreview') }}"></ara-spinner-button>
		<div [siTooltip]="t('settings.previewBeforeSafe')">
			<button (click)="saveSettings()" [disabled]="!formDirty()" class="m-2" color="primary" mat-raised-button name="submitSettingsButton" type="submit">
				<mat-icon>save</mat-icon>
				@if (!layoutService.isMobile()) {
					<span class="ml-1">
						{{ t('commonActions.save') }}
					</span>
				}
			</button>
		</div>
	</div>
</div>
